var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", { staticClass: "submit-button-text" }, [
    _vm._v(
      "\n  " +
        _vm._s(_vm.$t("messages_nl.search.show")) +
        " " +
        _vm._s(_vm.addDotsInNumber(_vm.houseCountVariable)) +
        " " +
        _vm._s(_vm.resultsName(_vm.houseCountVariable)) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }